import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
} from '@mui/material';

interface Props {
    open: boolean;
    userName: string;
    userTeam: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const UserSelectConfirmationDialog: React.FC<Props> = ({
    open,
    userName,
    userTeam,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Confirm Selection</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to move <strong>{userName}</strong> from team: <strong>{userTeam}</strong>?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};
